module.exports = __webpack_public_path__ + "static/media/Approved.3b629a32.svg";